var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0L0 2.30769V3.84615L10 1.53846L20 3.84615V2.30769L10 0ZM5.38462 4.61538C2.90231 4.61538 0.480769 5.62538 0.480769 5.62538L0 5.84077V17.6923H8.67769C8.94538 18.1523 9.43154 18.4615 10 18.4615C10.5677 18.4615 11.0546 18.1523 11.3223 17.6923H20V5.84154L19.5192 5.62538C19.5192 5.62538 17.0977 4.61538 14.6154 4.61538C12.3708 4.61538 10.4 5.36923 10 5.52923C9.6 5.36923 7.62923 4.61538 5.38462 4.61538ZM5.38462 6.15385C6.87231 6.15385 8.46154 6.63462 9.23077 6.89923V15.4569C8.37462 15.1746 6.96846 14.7838 5.38462 14.7838C3.76769 14.7838 2.45154 15.1562 1.53846 15.4569V6.89923C2.13077 6.68462 3.69231 6.15385 5.38462 6.15385ZM14.6154 6.15385C16.3077 6.15385 17.8692 6.68538 18.4615 6.89923V15.4569C17.5477 15.1569 16.2323 14.7838 14.6154 14.7838C13.0315 14.7838 11.6254 15.1746 10.7692 15.4569V6.89923C11.5385 6.63462 13.1277 6.15385 14.6154 6.15385Z",
    fill: "#727D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramIcon);
export default __webpack_public_path__ + "static/media/program_icon.05ea7a954aac221b8a0150e5f4d453af.svg";
export { ForwardRef as ReactComponent };